module.exports = __webpack_public_path__ + "media/images/orion_pictos/serenity-5721e9198daecf03c3c479d66af10872.svg";